import React from 'react';
import footerStyle from './style';
import ContactMeForm from '../ContactMeForm';

export default function Footer({mt, entries}) {
	let style = footerStyle();
	let onLanding = false;
	if (onLanding) {
		return <></>;
	} else {
		return (
			<>
				<ContactMeForm mt={true} addonStyle={style.contactMeContainer()} />
				<div style={style.outerStyle({mt: mt})}>
					{entries ? (
						entries.map((col, i) => {
							return (
								<div style={style.colStyle()} className={style.colClasses({i: i})} key={i}>
									{col.map((entrie, j) => {
										return (
											<a key={j} style={style.textStyle({text: entrie.name})} href={entrie.link}>
												{entrie.name}
											</a>
										);
									})}
								</div>
							);
						})
					) : (
						<></>
					)}
				</div>
			</>
		);
	}
}
